import React from "react";
import BitCoin from "../../../../assets/images/bitcoin.png";
import Ethereum from "../../../../assets/images/ethereum.png";
import LiteCoin from "../../../../assets/images/litecoin.png";
import Ripple from "../../../../assets/images/ripple.png";
import Image from "../../../elements/Image";
import Button from "../../../form/Button";

const coins = [
  {
    name: "Bitcoin",
    image: BitCoin,
    amount: "+$3,000",
    trend: "up",
    buttonLabel: "Sell",
    buttonClasses:
      "!px-4 !py-1.5 !h-8 !text-white !font-semibold !rounded-md !text-sm !bg-buttonRed !border !border-borderButtonRed",
  },
  {
    name: "Ethereum",
    image: Ethereum,
    amount: "+$2,100",
    trend: "down",
    buttonLabel: "Buy",
    buttonClasses:
      "!px-4 !py-1.5 !h-8 !text-white !font-semibold !rounded-md !text-sm !bg-primary",
  },
  {
    name: "LiteCoin",
    image: LiteCoin,
    amount: "+$2,100",
    trend: "down",
    buttonLabel: "Buy",
    buttonClasses:
      "!px-4 !py-1.5 !h-8 !text-white !font-semibold !rounded-md !text-sm !bg-primary",
  },


];

const Sell = () => {
  return (
    <div className="relative ">
      <section className="w-full bg-transparent border border-gray-200 rounded-3xl overflow-hidden p-4 relative">
        {/* <div className=" overflow-y-auto overflow-x-hidden max-h-[450px] h-full"> */}
        <div className="overflow-y-auto overflow-x-hidden max-h-[40vh] h-full custom-scroll">
          <table className="min-w-full border-separate border-spacing-y-3 w-full">
            <thead className="bg-tableHeader">
              <tr className="w-full">
                <th className="px-4 py-3 text-left text-shades-02 font-medium text-sm md:text-base rounded-tl-lg">
                  Coin
                </th>
                <th className="px-4 py-3 text-left text-shades-02 font-medium text-sm md:text-base">
                  Amount
                </th>
                <th className="px-4 py-3 text-left text-shades-02 font-medium text-sm md:text-base">
                  Chart
                </th> 
                <th className="px-4 py-3 text-left text-shades-02 font-medium text-sm md:text-base rounded-tr-lg">
                  {/* Action */}
                </th> 
              </tr>
            </thead>
            <tbody>
              {coins.map((coin, index) => (
                <tr key={index} className="bg-tableHeader overflow-hidden">
                  <td className="px-4 py-3  text-white">
                    <div className="w-5 h-5 md:w-6 md:h-6 rounded-md ">
                      <Image
                        src={coin.image}
                        width={100}
                        height={100}
                        classes="w-full h-full object-cover"
                      /> 
                    </div>
                  </td>
                  <td className="px-4 py-3 text-sm md:text-base text-shades-02">
                    {coin.amount}
                  </td>
                  <td className="px-4 py-3 text-sm md:text-base">
                    <i
                      className={`fa-light fa-arrow-trend-${coin.trend
                        } ${coin.trend === "up" ? "text-primary" : "text-red-500"}`}
                    ></i>
                  </td>
                  <td className="px-4 py-3 text-sm md:text-base  ">
                    <Button
                      buttonHasLink={false}
                      buttonLabel={coin.buttonLabel}
                      buttonClasses={coin.buttonClasses}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};

export default Sell;
